import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { xpentraLogoutSliceReset } from "../../../redux/features/logout/logout";
import { useDispatch } from "react-redux";
import PrimaryLargeButton from "../../../components/_utils/CommonButtons/PrimaryLargeButton";
import ICONS from "../../../assets/Icons";

const AdminContact = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  return (
    <div
      className="h-screen flex justify-center"
      style={{
        backgroundImage:
          "url('https://q2pay.in/new_assets/graphics/login/backgrond_for_login.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="w-full h-full grid place-items-center  Qlg:p-padding-base p-padding-sm">
        <div className="w-full Qsmd:w-fit rounded-border-radius-md p-[var(--border)] bg-[linear-gradient(154.44deg,rgba(97,117,153,0.5)_16.18%,rgba(100,100,100,0.5)_100.4%)] shadow-[0px_4px_4px_0px_#00000033]">
          <div className="Qsmd:p-padding-xl px-padding-sm py-padding-lg rounded-border-radius-md bg-primary-bg Qsmd:w-[var(--login-card-height)] w-full  h-fit">
            <div className="flex flex-col gap-gap-xl items-center">
              <h1 className="text-font-lg text-text-primary  font-semibold">
                {location?.state?.totp ? "Contact us" : "Contact your admin"}
              </h1>
              <div className="flex flex-col gap-gap-md items-center justify-between w-full">
                <div className="">
                  <img
                    src={ICONS?.CONTACT_ADMIN}
                    alt="bg_image"
                    className="w-[var(--graphic-square-height-md)]"
                  />
                </div>
                <p className="text-font-md text-text-primary text-center  ">
                  {location?.state?.totp
                    ? "Email our support team, and we’ll help you regain access to your account as quickly as possible."
                    : "Password can only be reset by your admin. Contact the admin and request them to reset password."}
                </p>
                {location?.state?.totp ? (
                  <p className="font-normal text-text-primary text-font-md">
                    Email us at :{" "}
                    <a
                      href="mailto:support@q2pay.in"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-pending font-semibold underline"
                    >
                      support@q2pay.in
                    </a>{" "}
                  </p>
                ) : (
                  <>
                    <h1 className="text-text-primary text-font-lg mt-margin-sm">
                      Steps for admin
                    </h1>
                    <span className="text-text-primary no-underline">
                      Open Q2Pay → Settings → Users <br /> → Select user → Reset
                      password{" "}
                    </span>
                    <h6 className="text-text-primary text-font-md mt-margin-sm">
                      Once the password is reset, you can log in again.
                    </h6>
                  </>
                )}
              </div>
              <div className="w-full flex flex-col gap-gap-md items-center">
                <div className="w-full flex justify-center">
                  <PrimaryLargeButton
                    btnType="button"
                    btnText="Back to login"
                    hoverOption="black"
                    enabledBgColor="var(--positive-act)"
                    enabledTextColor="var(--text-primary)"
                    disabledBgColor="var(--text-disabled)"
                    disabledTextColor="var(--text-primary)"
                    isDisabled={false}
                    handleFunction={() => {
                      sessionStorage.clear();
                      dispatch(xpentraLogoutSliceReset());
                      navigate("/login", { replace: true });
                    }}
                    isFillNeeded={true}
                    inActiveVariantNeeded={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden Qlg:d-flex flex-container text-center text-md-start gap-gap-md items-center fixed bottom-bottom-base Qsmd:mb-margin-lg mb-margin-xl">
        <div className="text-text-primary text-xs items-center">
          © Copyright {new Date().getFullYear()} Q2Pay Technologies Pvt Ltd. All
          rights reserved <span className="mx-margin-xs">|</span>
          <Link
            className="text-pending"
            to="/aboutus"
          >
            About Us
          </Link>
          <span className="mx-margin-xs">|</span>
          <Link
            className="text-pending"
            to="/privacy_policy"
          >
            Privacy
          </Link>
          <span className="mx-margin-xs">|</span>
          <Link
            className="text-pending"
            to="/terms_conditions"
          >
            Terms
          </Link>
        </div>
        <div className="text-text-primary text-xs items-center">
          <div
            tag="a"
            color="none"
            className="mx-margin-sm"
            style={{ color: "var(--text-primary)" }}
          >
            <a
              target="_blank"
              rel="noreferrer"
              href="https://ssl.comodo.com/ev-ssl-certificates.php"
            >
              <img
                src={"https://q2pay.in/new_assets/web/sectigo_trust_seal.png"}
                alt="trust_icon"
                className="img-fluid"
                style={{
                  margin: "auto",
                  display: "block",
                  width: "42px",
                  height: "17px",
                }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminContact;
